var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContenedorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: 512,
    viewBox: "0 0 512.000000 320.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,320.000000) scale(0.100000,-0.100000)",
    fill: "#FFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703 3027 c-580 -146 -645 -165 -670 -190 l-28 -27 0 -1220 0 -1220 26 -26 c23 -23 103 -45 660 -185 604 -151 639 -158 733 -159 130 0 3612 307 3640 321 11 6 29 21 38 33 16 20 18 100 18 1236 0 1314 3 1242 -50 1270 -20 11 -3603 331 -3682 329 -24 0 -332 -74 -685 -162z m2542 -215 l1660 -147 3 -1072 2 -1072 -32 -5 c-36 -6 -3332 -296 -3360 -296 -17 0 -18 72 -18 1370 l0 1370 43 -1 c23 0 789 -66 1702 -147z m-1965 -1222 c0 -742 -2 -1350 -5 -1350 -3 0 -98 23 -210 51 l-205 51 0 1249 0 1249 28 7 c15 3 101 26 192 49 91 23 173 43 183 43 16 1 17 -70 17 -1349z m-640 0 c0 -655 -2 -1190 -5 -1190 -3 0 -98 23 -210 51 l-205 51 0 1089 0 1089 28 7 c15 3 101 26 192 49 91 23 173 43 183 43 16 1 17 -62 17 -1189z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2661 2534 c-52 -37 -51 -18 -51 -944 0 -943 -2 -913 59 -944 50 -26 88 -21 127 18 l34 34 0 892 0 892 -34 34 c-27 27 -42 34 -73 34 -21 0 -49 -7 -62 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3903 2436 c-66 -30 -63 6 -63 -848 0 -712 1 -776 17 -798 27 -39 45 -49 90 -50 33 0 50 6 75 29 l33 29 0 791 0 791 -30 30 c-36 36 -79 45 -122 26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContenedorIcon);
export default __webpack_public_path__ + "static/media/contenedorIcon.bb2d17af883743750ae8e66631bf4343.svg";
export { ForwardRef as ReactComponent };